import Link from 'next/link'
import clsx from 'clsx'
import sidebarStyles from '../Sidebar.module.css'
import styles from './SidebarNavItem.module.css'

const SidebarNavItem = ({
	startIcon,
	content,
	href,
	onClick,
	...props
}): JSX.Element => {
	return (
		<li {...props}>
			<Link href={href} className={styles.navItem} onClick={onClick}>
				<span
					className={clsx(styles.hoverState, sidebarStyles.showWhenExpanded)}
				></span>
				<span className={styles.icon}>{startIcon}</span>
				<span className={clsx(styles.content, sidebarStyles.showWhenExpanded)}>
					{content}
				</span>
			</Link>
		</li>
	)
}

export default SidebarNavItem
